import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import attachments from './attachments'
/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/support',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::index
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:27
* @route 'https://org.proexpert.app/org/support'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
export const show = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/support/{case}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
show.url = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: args.case,
    }

    return show.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
show.get = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
show.head = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
const showForm = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
showForm.get = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::show
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:82
* @route 'https://org.proexpert.app/org/support/{case}'
*/
showForm.head = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::store
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:164
* @route 'https://org.proexpert.app/org/support'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/support',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::store
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:164
* @route 'https://org.proexpert.app/org/support'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::store
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:164
* @route 'https://org.proexpert.app/org/support'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::store
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:164
* @route 'https://org.proexpert.app/org/support'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportCaseController::store
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportCaseController.php:164
* @route 'https://org.proexpert.app/org/support'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::assign
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:19
* @route 'https://org.proexpert.app/org/support/{case}/assign'
*/
export const assign = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

assign.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/support/{case}/assign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::assign
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:19
* @route 'https://org.proexpert.app/org/support/{case}/assign'
*/
assign.url = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: args.case,
    }

    return assign.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::assign
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:19
* @route 'https://org.proexpert.app/org/support/{case}/assign'
*/
assign.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::assign
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:19
* @route 'https://org.proexpert.app/org/support/{case}/assign'
*/
const assignForm = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::assign
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:19
* @route 'https://org.proexpert.app/org/support/{case}/assign'
*/
assignForm.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

assign.form = assignForm

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::transition
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:31
* @route 'https://org.proexpert.app/org/support/{case}/transition'
*/
export const transition = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transition.url(args, options),
    method: 'post',
})

transition.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/support/{case}/transition',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::transition
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:31
* @route 'https://org.proexpert.app/org/support/{case}/transition'
*/
transition.url = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: args.case,
    }

    return transition.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::transition
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:31
* @route 'https://org.proexpert.app/org/support/{case}/transition'
*/
transition.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transition.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::transition
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:31
* @route 'https://org.proexpert.app/org/support/{case}/transition'
*/
const transitionForm = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: transition.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::transition
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:31
* @route 'https://org.proexpert.app/org/support/{case}/transition'
*/
transitionForm.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: transition.url(args, options),
    method: 'post',
})

transition.form = transitionForm

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::note
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:47
* @route 'https://org.proexpert.app/org/support/{case}/note'
*/
export const note = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: note.url(args, options),
    method: 'post',
})

note.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/support/{case}/note',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::note
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:47
* @route 'https://org.proexpert.app/org/support/{case}/note'
*/
note.url = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: args.case,
    }

    return note.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::note
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:47
* @route 'https://org.proexpert.app/org/support/{case}/note'
*/
note.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: note.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::note
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:47
* @route 'https://org.proexpert.app/org/support/{case}/note'
*/
const noteForm = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: note.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::note
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:47
* @route 'https://org.proexpert.app/org/support/{case}/note'
*/
noteForm.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: note.url(args, options),
    method: 'post',
})

note.form = noteForm

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::reply
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:64
* @route 'https://org.proexpert.app/org/support/{case}/reply'
*/
export const reply = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

reply.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/support/{case}/reply',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::reply
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:64
* @route 'https://org.proexpert.app/org/support/{case}/reply'
*/
reply.url = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: args.case,
    }

    return reply.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::reply
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:64
* @route 'https://org.proexpert.app/org/support/{case}/reply'
*/
reply.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::reply
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:64
* @route 'https://org.proexpert.app/org/support/{case}/reply'
*/
const replyForm = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportMessageController::reply
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportMessageController.php:64
* @route 'https://org.proexpert.app/org/support/{case}/reply'
*/
replyForm.post = (args: { case: string | number } | [caseParam: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

reply.form = replyForm

const support = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    store: Object.assign(store, store),
    assign: Object.assign(assign, assign),
    transition: Object.assign(transition, transition),
    note: Object.assign(note, note),
    reply: Object.assign(reply, reply),
    attachments: Object.assign(attachments, attachments),
}

export default support